// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Home Button

gameHistoryButton = {};

gameHistoryButton.create = function () {
  var button = new PIXI.Container();

  this._sideMenuOpen = false;

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button.canEnable = function () {
    return this._sideMenuOpen;
  };

  button.canShow = function () {
    return true;
  };

  button.onPressedCallback = function () {
    messageBus.postImmediate("ui:modal", { reason: "History open" });
    button._cbHistory();
    if (button.soundName !== "") button.playSound();
  };

  button.onConfig = function (config) {
    button._cbHistory = config.data.uiElements.cbHistory;
  };

  button.sideMenuOpenMsg = function () {
    this._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    this._sideMenuOpen = false;
  };

  messageBus.subscribe(
    "game:sideMenuOpen",
    button.sideMenuOpenMsg.bind(button)
  );
  messageBus.subscribe(
    "game:sideMenuClosed",
    button.sideMenuClosedMsg.bind(button)
  );
  messageBus.subscribe("spinner:GameConfigEvent", button.onConfig);

  return button;
};

gameHistoryButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};

gameHistoryButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "gameHistoryButton",
  gameHistoryButton.create,
  gameHistoryButton.initialise,
  gameHistoryButton.getFilesRequired
);
